<template lang="pug">
    .z-freight-view(v-if="$props.freight && $props.freight.id")
        .z-freight-title Основные характеристики
        
        .z-freight__value-container
            .z-freight__value.w-40
                .z-freight__value-label Количество мест:
                .z-freight__value-value {{$props.freight.seats_number}}

            .z-freight__value.w-30
                .z-freight__value-label Вес (кг):
                .z-freight__value-value {{$props.freight.weight}}

            .z-freight__value.w-30
                .z-freight__value-label 
                    span Объём м
                    sup 3
                    span :
                .z-freight__value-value {{$props.freight.size}}

            .z-freight__value.w-33
                .z-freight__value-value Оформление ТТН

            .z-freight__value.w-33(v-if='parseInt($props.freight.doom) > 0')
                .z-freight__value-value Обрешётка

            .z-freight__value.w-33(v-if="parseInt($props.freight.oversize) > 0")
                .z-freight__value-value Негабаритный груз


        .z-freight-title(v-if="servicesServices && servicesServices.length") Дополнительные услуги
        .z-freight__value-container
            .z-freight__value(v-for="item in servicesServices")
                .z-freight__value-label(v-if="item.label") {{item.label + ': '}}
                .z-freight__value-value {{item.value}}


        .z-freight-title(v-if="servicesPackage && servicesPackage.length") Тара и упаковка
        .z-freight__value-container
            .z-freight__value(v-for="item in servicesPackage")
                .z-freight__value-label(v-if="item.label") {{item.label + ': '}}
                .z-freight__value-value {{item.value}}
</template>
<script>
    export default {
        name: 'z-freight-view',
        components: {},
        props: {
            freight: {
                type: Object,
                defauld: () => {
                    return {};
                }
            }
        },
        data() {
            return {
                DBServices: []
            }
        },
        created() {
            this.init();
        },
        watch: {
            '$props.freight'(freight) {
                if (freight) this.init();
            }
        },
        computed: {
            freightServicesIds() {
                if (!this.$props.freight || !this.$props.freight.services) return [];
                return this.$props.freight.services.map(item => parseInt(item.id));
            },
            services() {
                if (!this.$props.freight || !this.$props.freight.services || !this.$props.freight.services.length || !this.DBServices || !this.DBServices.length || !this.freightServicesIds.length) return [];

                let result = [];

                this.DBServices.map(service => {
                    service.value = (service.type == 'checkbox') ? [] : null;
                    let values = service.values.filter(value => ((this.freightServicesIds.indexOf(parseInt(value.id))+1))).map(item => item.name);

                    if (values.length) {
                        let value = ((values.length == 1) ? values.find(item => !!item) : values);
                        result.push({
                            label: (value == service.name) ? null : service.name,
                            value: (typeof value == 'object') ? value.join(', ') : value,
                            section: service.section
                        });
                    }

                    return service;
                });
                
                return result;
            },
            servicesPackage() {
                if (!this.services || !this.services) return [];
                return this.services.filter(item => item.section == 'package');
            },
            servicesServices() {
                if (!this.services || !this.services) return [];
                return this.services.filter(item => item.section == 'services');
            },
        },
        methods: {
            init() {
                this.$nextTick(() => {
                   this.getServices(); 
                });
            },
            getServices(section) {
                this.DBServices = Object.assign([], []);
                let params = {order_by: 'sort', filter: {model: [['active','=','1']], relation: []}};
                return this.$store.dispatch('deals/getFreigtsServices', params).then(services => {
                    this.DBServices = Object.assign([], services);
                });
            }
        }
    }
</script>
<style lang="sass">
    .z-freight-view
        .z-freight-title
            font-size: 14px
            line-height: 16px
            font-weight: bold
            margin: 0 0 5px 0
        .z-freight__value-container
            display: flex
            align-items: flex-start
            justify-content: flex-start
            flex-wrap: wrap
        .z-freight__value
            display: flex
            align-items: flex-start
            justify-content: flex-start
            font-size: 12px
            line-height: 14px
            margin: 0 0 8px 0
            width: 100%  
            .z-freight__value-label
                color: #888888
                margin: 0 5px 0 0
                max-width: 40%
                sub
                    line-height: 0
            .z-freight__value-value
                color: #000
            &.w-40
                width: 40%
            &.w-30
                width: 30%
            &.w-33
                width: 33.3333%
            &.w-33, &.w-30, &.w-40
                .z-freight__value-label
                    max-width: 100%  
</style>


// WEBPACK FOOTER //
// ZFreightView.vue?35b342b1